<template>
  <div class="fenghuang">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'凤凰专区'}]"></breadcrumb>
    <div class="fenghuang-wrap">
      <div class="fenghuang-contain">
        <page-title title="单位列表">
          <el-button @click="addOrganization()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新增单位</span>
          </el-button>
        </page-title>
        <div class="fenghuang-search_wrap">
          <div class="fenghuang-search_left">
            <el-select clearable
                       @change="searchChange()"
                       placeholder="全部省份"
                       v-model="params.provincesId">
              <el-option v-for="item in providList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="fenghuang-search_right">
            <a class="fenghuang-table_download"
               @click="exportExcel()">
              <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                 :icon="['fas', 'level-up-alt']" />导出Excel</a>
            <el-input clearable
                      prefix-icon="el-icon-search"
                      v-model="params.name"
                      @keyup.enter.native="searchChange()"
                      placeholder="输入内容回车搜索"></el-input>
          </div>
        </div>
        <div class="fenghuang-table-wrap">
          <div class="fenghuang-table">
            <table>
              <tr>
                <th>省份</th>
                <th>单位</th>
                <th>组合</th>
                <th>定价</th>
                <th>点播用户</th>
                <th>订购用户</th>
                <th>月点击量</th>
                <th>点击排行</th>
                <th>上线时间</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item,index) in list"
                  :key="item.phid">
                <td>{{item.provincesName}}</td>
                <td>{{item.unitsname}}</td>
                <td>{{item.compoundModeName}}</td>
                <td>{{item.pricing}}</td>
                <td>{{item.unicastUser}}</td>
                <td>{{item.orderUser}}</td>
                <td>{{item.clickCount}}</td>
                <td>{{item.clickRank}}</td>
                <td>{{item.onlineTime}}</td>
                <td style="width:80px">
                  <a @click="editOrganization(index)">编辑</a>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="params.page"
                         class="fenghuang-pagination"
                         background
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog with="740px"
               :close-on-click-modal="false"
               class="fenghuang-dialog"
               title="产品信息编辑"
               :visible.sync="showForm">
      <el-form label-position="top"
               class="fenghuang-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="单位名称">
              <el-input v-model="clientForm.unitsname" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="省份">
             <el-select  v-model="clientForm.provincesId">
                <el-option
                  v-for="item in providList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组合方式">
             <el-select  v-model="clientForm.compoundMode">
                <el-option
                  v-for="item in compoundModeList"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="产品信息">
              <el-input v-model="clientForm.productInfo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="订购用户">
              <el-input v-model="clientForm.orderUser" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="点播用户">
              <el-input v-model="clientForm.unicastUser" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="点击排行">
              <el-input v-model="clientForm.clickRank" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="月点击数">
              <el-input v-model="clientForm.monthClick" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="总点击数">
              <el-input v-model="clientForm.clickCount" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上线时间">
               <el-date-picker v-model="clientForm.onlineTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
       <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submit()" :loading="dialogLoading">提 交</el-button>
        <el-button @click="showForm = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import pageTitle from '@/components/pageTitle'
export default {
  components: {
    breadcrumb,
    pageTitle
  },
  data() {
    return {
      total: 0,
      providList: [],
      compoundModeList:[],
      params: {
        provincesId: '',
        name: '',
        page: 1,
        pageSize: 10
      },
      list: [],

      clientForm: {
        clickCount: '',
        clickRank: '',
        compoundMode: '',
        monthClick: '',
        onlineTime: '',
        orderUser: '',
        phid: '',
        pricing: '',
        productInfo: '',
        provincesId: '',
        unicastUser: '',
        unitsname: ''
      },
      dialogLoading: false,
      showForm: false
    }
  },
  created() {
    this.getSelectList()
    this.getList()
  },
  methods: {
    //加载添加单位Form种的下拉框
    getSelectList() {
      Promise.all([
        //获取省-市-区列表
        axios.post(api.areaList).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        }),
        axios.get(api.getVodTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取组合方式成功', res.data.result)
            this.compoundModeList = res.data.result
          } else {
            console.log('获取组合方式失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    getList() {
      axios
        .post(api.phtvList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取凤凰专区列表成功', res.data.result)
            this.list = res.data.result.records
            this.total = res.data.result.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    searchChange() {
      this.page = 1
      this.getList()
    },
    changePage(v) {
      this.params.page = v
    },
    exportExcel() {},
    //新增单位
    addOrganization() {
      this.clientForm = {
        clickCount: '',
        clickRank: '',
        compoundMode: '',
        monthClick: '',
        onlineTime: '',
        orderUser: '',
        pricing: '',
        productInfo: '',
        provincesId: '',
        unicastUser: '',
        unitsname: ''
      }
      this.showForm = true
    },
    editOrganization(index){
      this.clientForm = _.pick(this.list[index],_.keys(this.clientForm))
      this.clientForm.phid = this.list[index].phid
      this.showForm = true
    },
    //提交信息
    submit(){
      this.dialogLoading =true
      if(this.clientForm.phid){
 axios
        .post(api.updatePhtv, this.clientForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "编辑单位成功",
              type: "success"
            });
            this.showForm = false;
            this.dialogLoading = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
            this.dialogLoading = false;
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
          this.dialogLoading = false;
        });
      } else{
        axios
        .post(api.addPhtv, this.clientForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "添加单位成功",
              type: "success"
            });
            this.showForm = false;
            this.dialogLoading = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
            this.dialogLoading = false;
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
          this.dialogLoading = false;
        });

      }

    }
  }
}
</script>

<style lang="scss" scoped>
.fenghuang {
  .fenghuang-wrap {
    padding: 77px 30px 0px 30px;
    .fenghuang-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .fenghuang-search_wrap {
        background: #f8f8f8;
        padding: 20px 27px;
        display: flex;
        .fenghuang-search_left {
          display: flex;
          flex: 1;
        }
        .el-input {
          width: 178px;
        }
        .fenghuang-search_right {
          display: flex;
          .fenghuang-table_download {
            cursor: pointer;
            text-decoration: none;
            width: 108px;
            height: 38px;
            margin-right: 10px;
            border-radius: 4px;
            background: #fff;
            margin-left: 20px;
            border: 1px solid rgba(220, 223, 230, 1);
            color: #9b9b9b;
            font-size: 14px;
            font-weight: 500;
            line-height: 38px;
            text-align: center;
          }
        }
      }
      .fenghuang-table-wrap {
        padding: 30px;
        .fenghuang-table {
          min-height: 470px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .fenghuang-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .fenghuang-dialog{
    .el-date-editor {
          width: 100%;
        }
  }
}
</style>
